import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import { makeMarketplaceAppPricingFromRawAppPricing } from "./types/MarketplaceAppPricing";
export var getRawMarketplaceAppPricing = function getRawMarketplaceAppPricing(mpacBaseUrl, appKey) {
  var currencyCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'USD';
  var hostingType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cloud';
  return fetchOk("".concat(mpacBaseUrl, "/rest/2/addons/").concat(appKey, "/pricing/").concat(hostingType, "/live?currencyCode=").concat(currencyCode)).then(function (response) {
    return response.json();
  });
};
export var getMarketplaceAppPricing = function getMarketplaceAppPricing(mpacBaseUrl, appKey, currencyCode) {
  return getRawMarketplaceAppPricing(mpacBaseUrl, appKey, currencyCode).then(makeMarketplaceAppPricingFromRawAppPricing);
};